import { EMAIL_ITEM_ID_KEY } from '../../../../../Email'

export function getActiveItemData(items, activeItem) {
  return items?.find(item => item[EMAIL_ITEM_ID_KEY] === activeItem)
}
